module.exports = __webpack_public_path__ + "0981669a30c37a85ea0c9b681b538bc7.woff";